import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-white border-t border-stone-200 py-4 px-6 mt-auto">
      <div className="max-w-7xl mx-auto flex items-center justify-between flex-wrap gap-3 text-xs text-gray-400 font-nunito">
        <span>© 2026 Neighborli. All rights reserved.</span>
        <div className="flex items-center gap-4 flex-wrap">
          <Link
            to="/terms"
            data-testid="footer-terms-link"
            className="hover:text-[#004B00] transition-colors"
          >
            Terms of Service
          </Link>
          <Link
            to="/privacy"
            data-testid="footer-privacy-link"
            className="hover:text-[#004B00] transition-colors"
          >
            Privacy Policy
          </Link>
          <Link
            to="/security"
            data-testid="footer-security-link"
            className="hover:text-[#004B00] transition-colors"
          >
            Security
          </Link>
          <a
            href="mailto:support@neighborli.net"
            className="hover:text-[#004B00] transition-colors"
          >
            Contact
          </a>
        </div>
      </div>
    </footer>
  );
}
